<template>
  <div style="position: relative" v-click-outside="blurMore">
    <button
      type="button"
      @click="showMore"
      class="orders-page-table__dots"
      style="display: inline-flex"
    >
      <icon name="more-v" />
    </button>
    <div
      class="drop-select"
      v-show="visible"
      ref="select"
      :class="{ 'drop-select--top': moreTop }"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "DropMenuSelect",
  data: () => ({
    visible: false,
    moreTop: false
  }),
  methods: {
    showMore() {
      this.visible = !this.visible;
      if (this.visible) {
        this.$nextTick(() => {
          if (this.$refs.select) {
            const height = this.$refs.select.clientHeight;
            const top = this.$refs.select.getBoundingClientRect().top;
            if (top + height > window.innerHeight) {
              this.moreTop = true;
              return;
            }
            this.moreTop = false;
          }
        });
      }
    },
    blurMore() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss">
.drop-select {
  background: var(--white);
  box-shadow: 0 15px 60px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translateY(100%);
  min-width: 120px;
  z-index: 12;

  &--top {
    bottom: initial;
    top: 0;
    transform: translateY(-100%);
  }

  a {
    color: var(--dark);
    text-decoration: none;
    font-size: 0.75rem;
    padding: 5px 10px;

    &:hover {
      background: var(--gray-darker);
    }
  }
}
</style>
